import tooltipCopy from '../tooltipCopy';

const { defineMessages } = require('@sm/intl');

const TYPE_LABEL = '[Type: Label][Vis: high] - Feature Set List Item';

export default defineMessages({
  ...tooltipCopy,
  '508_accessibility': {
    id: 'PricingSummary.Feature.508Accessibility',
    defaultMessage: 'ADA compliant',
    desc: TYPE_LABEL,
  },
  a_b_testing: {
    id: 'PricingSummary.Feature.ABTesting',
    defaultMessage: 'A/B testing, randomization, quotas',
    desc: TYPE_LABEL,
  },
  account_control: {
    id: 'PricingSummary.Feature.AccountControl',
    defaultMessage: 'Account control and migration',
    desc: TYPE_LABEL,
  },
  account_verification: {
    id: 'PricingSummary.Feature.AccountVerification',
    defaultMessage: 'Account Verification',
    desc: TYPE_LABEL,
  },
  add_users: {
    id: 'PricingSummary.Feature.AddUsers',
    defaultMessage: 'Add Users',
    desc: TYPE_LABEL,
  },
  admin_dashboard: {
    id: 'PricingSummary.Feature.AdminDashboard',
    defaultMessage: 'Admin dashboard and user management',
    desc: TYPE_LABEL,
  },
  advanced_analyze_features: {
    id: 'PricingSummary.Feature.AdvancedAnalyzeFeatures',
    defaultMessage: 'Advanced analyze features',
    desc: TYPE_LABEL,
  },
  advanced_collaboration: {
    id: 'PricingSummary.Feature.AdvancedCollaborationFeatures',
    defaultMessage: 'Advanced collaboration features',
    desc: TYPE_LABEL,
  },
  advanced_logic: {
    id: 'PricingSummary.Feature.AdvancedLogic',
    defaultMessage: 'Advanced survey logic tools',
    desc: TYPE_LABEL,
  },
  all_data_exports: {
    id: 'PricingSummary.Feature.AllDataExports',
    defaultMessage: 'All data exports (CSV, XLS, PPT, PDF, SPSS)',
    desc: TYPE_LABEL,
  },
  all_languages_supported: {
    id: 'PricingSummary.Feature.AllLanguagesSupported',
    defaultMessage: 'All Languages Supported',
    desc: TYPE_LABEL,
  },
  analyze_access_benchmarking: {
    id: 'PricingSummary.Feature.AnalyzeAccessBenchmarking',
    defaultMessage: 'Analyze Access Benchmarking',
    desc: TYPE_LABEL,
  },
  analyze_can_customize_charts: {
    id: 'PricingSummary.Feature.AnalyzeCanCustomizeCharts',
    defaultMessage: 'Analyze Custom Charts',
    desc: TYPE_LABEL,
  },
  analyze_can_export_ta: {
    id: 'PricingSummary.Feature.AnalyzeCanExportTA',
    defaultMessage: 'Analyze Export TA',
    desc: TYPE_LABEL,
  },
  analyze_can_save_views: {
    id: 'PricingSummary.Feature.AnalyzeCanSaveViews',
    defaultMessage: 'Analyze Save Views',
    desc: TYPE_LABEL,
  },
  analyze_can_share_customize_branding: {
    id: 'PricingSummary.Feature.AnalyzeCanShareCustomizeBranding',
    defaultMessage: 'Customization and branding',
    desc: TYPE_LABEL,
  },
  analyze_can_share_customize_domain: {
    id: 'PricingSummary.Feature.AnalyzeCanShareCustomizeDomain',
    defaultMessage: 'Analyze Share Customize Domain',
    desc: TYPE_LABEL,
  },
  analyze_can_ta_search: {
    id: 'PricingSummary.Feature.AnalyzeCanTASearch',
    defaultMessage: 'Analyze TA Search',
    desc: TYPE_LABEL,
  },
  analyze_can_ta_tag: {
    id: 'PricingSummary.Feature.AnalyzeCanTATag',
    defaultMessage: 'Analyze TA Tag',
    desc: TYPE_LABEL,
  },
  analyze_combine_filters: {
    id: 'PricingSummary.Feature.CombineFilters',
    defaultMessage: 'Unlimited filter and compare rules, data trends',
    desc: TYPE_LABEL,
  },
  analyze_dashboard_password_enabled: {
    id: 'PricingSummary.Feature.AnalyzeDashboardPasswordEnabled',
    defaultMessage: 'Analyze Dashboard Password',
    desc: TYPE_LABEL,
  },
  analyze_delete_respondent_limit: {
    id: 'PricingSummary.Feature.AnalyzeDeleteRespondentLimit',
    defaultMessage: 'Analyze Delete Respondent Limit',
    desc: TYPE_LABEL,
  },
  analyze_export_enabled: {
    id: 'PricingSummary.Feature.AnalyzeExportEnabled',
    defaultMessage: 'Data exports (CSV, PDF, PPT, XLS)',
    desc: TYPE_LABEL,
  },
  analyze_export_spss_enabled: {
    id: 'PricingSummary.Feature.AnalyzeExportSpssEnabled',
    defaultMessage: 'Advanced data exports (SPSS)',
    desc: TYPE_LABEL,
  },
  analyze_integrations: {
    id: 'PricingSummary.Feature.AnalyzeIntegrations',
    defaultMessage: 'Free integrations with popular collaboration apps',
    desc: TYPE_LABEL,
  },
  analyze_password_enabled: {
    id: 'PricingSummary.Feature.AnalyzePasswordEnabled',
    defaultMessage: 'Analyze Password Enabled',
    desc: TYPE_LABEL,
  },
  analyze_response_delete_limit: {
    id: 'PricingSummary.Feature.AnalyzeResponseDeleteLimit',
    defaultMessage: 'Analyze Response Delete Limit',
    desc: TYPE_LABEL,
  },
  analyze_response_limit: {
    id: 'PricingSummary.Feature.AnalyzeResponseLimit',
    defaultMessage: 'Unlimited responses per year/month/survey',
    desc: TYPE_LABEL,
  },
  analyze_results_together: {
    id: 'PricingSummary.Feature.AnalyzeResultsTogether',
    defaultMessage: 'Let team members analyze, filter, and export results',
    desc: TYPE_LABEL,
  },
  analyze_rule_based_tagging: {
    id: 'PricingSummary.Feature.AnalyzeRuleBasedTagging',
    defaultMessage: 'Analyze Rule Based Tagging',
    desc: TYPE_LABEL,
  },
  analyze_rule_limit: {
    id: 'PricingSummary.Feature.AnalyzeRuleLimit',
    defaultMessage: 'Analyze Rule Limit',
    desc: TYPE_LABEL,
  },
  sentiment: {
    id: 'PricingSummary.Feature.AnalyzeSentimentEnabled',
    defaultMessage: 'Sentiment analysis',
    desc: TYPE_LABEL,
  },
  analyze_shared_results_enabled: {
    id: 'PricingSummary.Feature.AnalyzeSharedResultsEnabled',
    defaultMessage: 'Analyze Shared Results Enabled',
    desc: TYPE_LABEL,
  },
  analyze_ta_enabled: {
    id: 'PricingSummary.Feature.AnalyzeTAEnabled',
    defaultMessage: 'Analyze TA Enabled',
    desc: TYPE_LABEL,
  },
  analyze_trends_enabled: {
    id: 'PricingSummary.Feature.AnalyzeTrendsEnabled',
    defaultMessage: '1 filter',
    desc: TYPE_LABEL,
  },
  api_access: {
    id: 'PricingSummary.Feature.ApiAccess',
    defaultMessage: 'API Access',
    desc: TYPE_LABEL,
  },
  asset_library: {
    id: 'PricingSummary.Feature.AssetLibrary',
    defaultMessage: 'Shared asset library for on-brand surveys',
    desc: TYPE_LABEL,
  },
  assign_admin_role: {
    id: 'PricingSummary.Feature.AssignAdminRole',
    defaultMessage: 'Assign Admin Role',
    desc: TYPE_LABEL,
  },
  base_response_count: {
    id: 'PricingSummary.Feature.BaseResponseCount',
    defaultMessage: '{amount} responses per year**',
    desc: TYPE_LABEL,
  },
  benchmarks: {
    id: 'PricingSummary.Feature.Benchmarks',
    defaultMessage: 'SurveyMonkey industry benchmarks',
    desc: TYPE_LABEL,
  },
  best_worst_qt: {
    id: 'PricingSummary.Feature.BestWorstQT',
    defaultMessage: 'Best Worst QT',
    desc: TYPE_LABEL,
  },
  block_randomization: {
    id: 'PricingSummary.Feature.BlockRandomization',
    defaultMessage: 'Block randomization',
    desc: TYPE_LABEL,
  },
  build_surveys_together: {
    id: 'PricingSummary.Feature.BuildSurveysTogether',
    defaultMessage: 'Build Surveys Together',
    desc: TYPE_LABEL,
  },
  bulk_survey_share: {
    id: 'PricingSummary.Feature.BulkSurveyShare',
    defaultMessage: 'Bulk Survey Share',
    desc: TYPE_LABEL,
  },
  bulk_survey_transfer: {
    id: 'PricingSummary.Feature.BulkSurveyTransfer',
    defaultMessage: 'Bulk Survey Transfer',
    desc: TYPE_LABEL,
  },
  carry_forward: {
    id: 'PricingSummary.Feature.CarryForward',
    defaultMessage: 'Carry Forward',
    desc: TYPE_LABEL,
  },
  click_map_qt: {
    id: 'PricingSummary.Feature.ClickMapQT',
    defaultMessage: 'Click map data visualization',
    desc: TYPE_LABEL,
  },
  collaborate: {
    id: 'PricingSummary.Feature.Collaborate',
    defaultMessage: 'Survey sharing with fine control over who can view and edit',
    desc: TYPE_LABEL,
  },
  collect_contact_information: {
    id: 'PricingSummary.Feature.CollectContactInformation',
    defaultMessage: 'Collect Contact Information',
    desc: TYPE_LABEL,
  },
  collect_email_throttle_limit: {
    id: 'PricingSummary.Feature.CollectEmailThrottleLimit',
    defaultMessage: 'Collect Email Throttle Limit',
    desc: TYPE_LABEL,
  },
  collect_min_daily_messages_limit: {
    id: 'PricingSummary.Feature.CollectMinDailyMessagesLimit',
    defaultMessage: 'Collect Min Daily Messages Limit',
    desc: TYPE_LABEL,
  },
  collect_responses: {
    id: 'PricingSummary.Feature.CollectResponses',
    defaultMessage: 'Collect Responses',
    desc: TYPE_LABEL,
  },
  collector_completion_url_enabled: {
    id: 'PricingSummary.Feature.CollectorCompletionUrlEnabled',
    defaultMessage: 'Survey completion redirect',
    desc: TYPE_LABEL,
  },
  collector_contact_list_limit: {
    id: 'PricingSummary.Feature.CollectorContactListLimit',
    defaultMessage: 'Collector Contact List Limit',
    desc: TYPE_LABEL,
  },
  collector_create_limit: {
    id: 'PricingSummary.Feature.CollectorCreateLimit',
    defaultMessage: 'Collector Create Limit',
    desc: TYPE_LABEL,
  },
  collector_email_limit: {
    id: 'PricingSummary.Feature.CollectorEmailLimit',
    defaultMessage: 'Collector Email Limit',
    desc: TYPE_LABEL,
  },
  collector_email_enabled: {
    id: 'PricingSummary.Feature.CollectorEmailEnabled',
    defaultMessage: 'Collector Email Enabled',
    desc: TYPE_LABEL,
  },
  collector_facebook_messenger_enabled: {
    id: 'PricingSummary.Feature.CollectorFacebookMessengerEnabled',
    defaultMessage: 'Collector Facebook Messenger Enabled',
    desc: TYPE_LABEL,
  },
  collector_manual_data_entry_enabled: {
    id: 'PricingSummary.Feature.CollectorManualDataEntryEnabled',
    defaultMessage: 'Collector Manuanl Data Entry Enabled',
    desc: TYPE_LABEL,
  },
  collector_mobile_sdk_enabled: {
    id: 'PricingSummary.Feature.CollectorMobileSdkEnabled',
    defaultMessage: 'Collector Mobile SDK Enabled',
    desc: TYPE_LABEL,
  },
  collector_offline_kiosk_enabled: {
    id: 'PricingSummary.Feature.CollectorOfflineKioskEnabled',
    defaultMessage: 'Collector Offline Kiosk Enabled',
    desc: TYPE_LABEL,
  },
  collector_popup_enabled: {
    id: 'PricingSummary.Feature.CollectorPopupEnabled',
    defaultMessage: 'Pop up online surveys',
    desc: TYPE_LABEL,
  },
  collector_friendly_url_enabled: {
    id: 'PricingSummary.Feature.CollectorFriendlyUrlEnabled',
    defaultMessage: 'Custom logo, colors, and survey URL',
    desc: TYPE_LABEL,
  },
  collector_max_responses_delete_count: {
    id: 'PricingSummary.Feature.CollectorMaxResponsesDeleteCount',
    defaultMessage: 'Collector Max Responses Delete Count',
    desc: TYPE_LABEL,
  },
  collector_recipients_limit: {
    id: 'PricingSummary.Feature.CollectorRecipientsLimit',
    defaultMessage: 'Collector Recipients Limit',
    desc: TYPE_LABEL,
  },
  collector_thank_you_enabled: {
    id: 'PricingSummary.Feature.CollectorThankYouEnabled',
    defaultMessage: 'Collector Thank You Enabled',
    desc: TYPE_LABEL,
  },
  collector_white_label_enabled: {
    id: 'PricingSummary.Feature.CollectorWhiteLabelEnabled',
    defaultMessage: 'White label surveys',
    desc: TYPE_LABEL,
  },
  collector_zoom_enabled: {
    id: 'PricingSummary.Feature.CollectorZoomEnabled',
    defaultMessage: 'Collector Zoom Enabled',
    desc: TYPE_LABEL,
  },
  collectors_read: {
    id: 'PricingSummary.Feature.CollectorsRead',
    defaultMessage: 'Collectors Read',
    desc: TYPE_LABEL,
  },
  collectors_write: {
    id: 'PricingSummary.Feature.CollectorsWrite',
    defaultMessage: 'Collectors Write',
    desc: TYPE_LABEL,
  },
  collect_end_page_question_bank_demographics: {
    id: 'PricingSummary.Feature.CollectEndPageQuestionBankDemographics',
    defaultMessage: 'Collect End Page Question Bank Demographics',
    desc: TYPE_LABEL,
  },
  comment_box_question_type: {
    id: 'PricingSummary.Feature.CommentBoxQuestionType',
    defaultMessage: 'Comment Box Question Type',
    desc: TYPE_LABEL,
  },
  consolidated_billing: {
    id: 'PricingSummary.Feature.ConsolidatedBilling',
    defaultMessage: 'Consolidatd Billing',
    desc: TYPE_LABEL,
  },
  contacts_read: {
    id: 'PricingSummary.Feature.ContactsRead',
    defaultMessage: 'Contacts Read',
    desc: TYPE_LABEL,
  },
  contacts_write: {
    id: 'PricingSummary.Feature.ContactsWrite',
    defaultMessage: 'Contacts Write',
    desc: TYPE_LABEL,
  },
  contributor_seats: {
    id: 'PricingSummary.Feature.ContributorSeats',
    defaultMessage: 'Add Contributor Seats',
    desc: TYPE_LABEL,
  },
  create_advanced_features: {
    id: 'PricingSummary.Feature.CreateAdvancedFeatures',
    defaultMessage: 'A/B testing, randomization, quotas',
    desc: TYPE_LABEL,
  },
  create_custom_chatbot_avatar: {
    id: 'PricingSummary.Feature.CreateCustomChatbotAvatar',
    defaultMessage: 'Create Custom Chatbot Avatar',
    desc: TYPE_LABEL,
  },
  create_custom_html_email_message_enabled: {
    id: 'PricingSummary.Feature.CreateCustomHtmlEmailMessageEnabled',
    defaultMessage: 'Create Custom Html Email Message Enabled',
    desc: TYPE_LABEL,
  },
  create_custom_theme_enabled: {
    id: 'PricingSummary.Feature.CreateCustomThemeEnabled',
    defaultMessage: 'Create Custom Theme Enabled',
    desc: TYPE_LABEL,
  },
  create_custom_variables_enabled: {
    id: 'PricingSummary.Feature.CreateCustomVariablesEnabled',
    defaultMessage: 'Custom variables',
    desc: TYPE_LABEL,
  },
  create_grayscale_footer: {
    id: 'PricingSummary.Feature.CreateGrayscaleFooter',
    defaultMessage: 'Create Grayscale Footer Enabled',
    desc: TYPE_LABEL,
  },
  create_logo_enabled: {
    id: 'PricingSummary.Feature.CreateLogoEnabled',
    defaultMessage: 'Create Logo Enabled',
    desc: TYPE_LABEL,
  },
  create_piping_enabled: {
    id: 'PricingSummary.Feature.CreatePipingEnabled',
    defaultMessage: 'Skip logic, question & answer piping',
    desc: TYPE_LABEL,
  },
  create_print_enabled: {
    id: 'PricingSummary.Feature.CreatePrintEnabled',
    defaultMessage: 'Create Print Enabled',
    desc: TYPE_LABEL,
  },
  create_question_limit: {
    id: 'PricingSummary.Feature.CreateQuestionLimit',
    defaultMessage: 'Unlimited surveys and questions',
    desc: TYPE_LABEL,
  },
  create_quotas_enabled: {
    id: 'PricingSummary.Feature.CreateQuotasEnabled',
    defaultMessage: 'Create Quotas Enabled',
    desc: TYPE_LABEL,
  },
  create_random_assignment_enabled: {
    id: 'PricingSummary.Feature.CreateRandomAssignmentEnabled',
    defaultMessage: 'A/B test text and images',
    desc: TYPE_LABEL,
  },
  create_randomization_enabled: {
    id: 'PricingSummary.Feature.CreateRandomizationEnabled',
    defaultMessage: 'Create Randomization Enabled',
    desc: TYPE_LABEL,
  },
  skip_logic: {
    id: 'PricingSummary.Feature.CreateSkipLogicEnabled',
    defaultMessage: 'Skip logic only',
    desc: TYPE_LABEL,
  },
  create_templates_enabled: {
    id: 'PricingSummary.Feature.CreateTemplatesEnabled',
    defaultMessage: 'Create Templates Enabled',
    desc: TYPE_LABEL,
  },
  create_toggle_footer_enabled: {
    id: 'PricingSummary.Feature.CreateToggleFooterEnabled',
    defaultMessage: 'Hide SurveyMonkey footer',
    desc: TYPE_LABEL,
  },
  custom_charts: {
    id: 'PricingSummary.Feature.CustomCharts',
    defaultMessage: 'Custom Charts',
    desc: TYPE_LABEL,
  },
  custom_templates: {
    id: 'PricingSummary.Feature.CustomTemplates',
    defaultMessage: 'Custom Templates',
    desc: TYPE_LABEL,
  },
  customer_success: {
    id: 'PricingSummary.Feature.CustomerSuccess',
    defaultMessage: 'Dedicated customer success manager***',
    desc: TYPE_LABEL,
  },
  customize_disqualification_page_enabled: {
    id: 'PricingSummary.Feature.CustomizeDisqualificationPageEnabled',
    defaultMessage: 'Customize Disqualification Page Enabled',
    desc: TYPE_LABEL,
  },
  data_ownership: {
    id: 'PricingSummary.Feature.DataOwnership',
    defaultMessage: 'Data Ownership',
    desc: TYPE_LABEL,
  },
  disable_closed_page_branding_enabled: {
    id: 'PricingSummary.Feature.DisableClosedPageBrandingEnbabled',
    defaultMessage: 'Disable Closed Page Branding Enabled',
    desc: TYPE_LABEL,
  },
  disable_email_message_branding_enabled: {
    id: 'PricingSummary.Feature.DisableEmailMessageBrandingEnbabled',
    defaultMessage: 'Disable Email Message Branding Enabled',
    desc: TYPE_LABEL,
  },
  disable_footer_branding_enabled: {
    id: 'PricingSummary.Feature.DisableFooterBrandingEnbabled',
    defaultMessage: 'Disable Footer Branding Enabled',
    desc: TYPE_LABEL,
  },
  download_as_csv_xls_pdf: {
    id: 'PricingSummary.Feature.DownloadAsCsvXlsPdf',
    defaultMessage: 'Download as Csv/Xls/Pdf',
    desc: TYPE_LABEL,
  },
  download_as_ppt: {
    id: 'PricingSummary.Feature.DownloadAsPpt',
    defaultMessage: 'Download as Ppt',
    desc: TYPE_LABEL,
  },
  email_support: {
    id: 'PricingSummary.Feature.EmailSupport',
    defaultMessage: '24/7 customer support via email',
    desc: TYPE_LABEL,
  },
  email_tracking_enabled: {
    id: 'PricingSummary.Feature.EmailTrackingEnabled',
    defaultMessage: 'Email Tracking Enabled',
    desc: TYPE_LABEL,
  },
  enable_ip_blocking: {
    id: 'PricingSummary.Feature.EnableIpBlocking',
    defaultMessage: 'Enable Ip Blocking',
    desc: TYPE_LABEL,
  },
  enhanced_governance: {
    id: 'PricingSummary.Feature.EnhancedGovernance',
    defaultMessage: 'Enhanced governance and security features',
    desc: TYPE_LABEL,
  },
  essential_question_types: {
    id: 'PricingSummary.Feature.EssentialQuestionTypes',
    defaultMessage: 'Essential Question Types',
    desc: TYPE_LABEL,
  },
  extended_piping: {
    id: 'PricingSummary.Feature.ExtendedPiping',
    defaultMessage: 'Advanced branching & piping, block randomization',
    desc: TYPE_LABEL,
  },
  extract_data: {
    id: 'PricingSummary.Feature.ExtractData',
    defaultMessage: 'Extract Data',
    desc: TYPE_LABEL,
  },
  file_upload: {
    id: 'PricingSummary.Feature.FileUpload',
    defaultMessage: 'File upload',
    desc: TYPE_LABEL,
  },
  filter_crosstab: {
    id: 'PricingSummary.Feature.FilterCrosstab',
    defaultMessage: 'Filter Crosstab',
    desc: TYPE_LABEL,
  },
  flexible_plan_types: {
    id: 'PricingSummary.Feature.FlexiblePlanTypes',
    defaultMessage: 'Flexible plan types for multiple users',
    desc: TYPE_LABEL,
  },
  footer_branding: {
    id: 'PricingSummary.Feature.AnalyzeCanExportHideBranding',
    defaultMessage: 'Remove SurveyMonkey footer',
    desc: TYPE_LABEL,
  },
  funneling_enabled: {
    id: 'PricingSummary.Feature.FunnelingEnabled',
    defaultMessage: 'Funneling Enabled',
    desc: TYPE_LABEL,
  },
  gather_comments: {
    id: 'PricingSummary.Feature.GatherComments',
    defaultMessage: 'Gather comments all in one place',
    desc: TYPE_LABEL,
  },
  gold_features_included: {
    id: 'PricingSummary.Feature.GoldFeaturesIncluded',
    defaultMessage: 'Gold Features Included',
    desc: TYPE_LABEL,
  },
  group_contacts_limit: {
    id: 'PricingSummary.Feature.GroupContactsLimit',
    defaultMessage: 'Group Contacts Limit',
    desc: TYPE_LABEL,
  },
  group_templates: {
    id: 'PricingSummary.Feature.GroupTemplates',
    defaultMessage: 'Group Templates',
    desc: TYPE_LABEL,
  },
  groups_read: {
    id: 'PricingSummary.Feature.GroupsRead',
    defaultMessage: 'Groups Read',
    desc: TYPE_LABEL,
  },
  groups_write: {
    id: 'PricingSummary.Feature.GroupsWrite',
    defaultMessage: 'Groups Write',
    desc: TYPE_LABEL,
  },
  hide_export_branding_enabled: {
    id: 'PricingSummary.Feature.HideExportBrandingEnabled',
    defaultMessage: 'Hide Export Branding Enabled',
    desc: TYPE_LABEL,
  },
  hipaa_enabled: {
    id: 'PricingSummary.Feature.HipaaEnabled',
    defaultMessage: 'HIPAA-compliant features***',
    desc: TYPE_LABEL,
  },
  integrations: {
    id: 'PricingSummary.Feature.HipaaEnabled',
    defaultMessage: 'Integrations with Salesforce, Marketo, Eloqua, and Tableau***',
    desc: TYPE_LABEL,
  },
  kiosk_mode_inactivity_timer: {
    id: 'PricingSummary.Feature.KioskModeInactivityTimer',
    defaultMessage: 'Kiosk Mode Inactivity Timer',
    desc: TYPE_LABEL,
  },
  kiosk_mode_passcode_lock: {
    id: 'PricingSummary.Feature.KioskModePasscodeLock',
    defaultMessage: 'Kiosk Mode Passcode Lock',
    desc: TYPE_LABEL,
  },
  labeling_titles_numbering: {
    id: 'PricingSummary.Feature.LabelingTitlesNumbering',
    defaultMessage: 'Labeling Titles Numbering',
    desc: TYPE_LABEL,
  },
  library_read: {
    id: 'PricingSummary.Feature.LibraryRead',
    defaultMessage: 'Library Read',
    desc: TYPE_LABEL,
  },
  lite_library: {
    id: 'PricingSummary.Feature.LiteLibrary',
    defaultMessage: 'Lite Library',
    desc: TYPE_LABEL,
  },
  max_collectors_per_survey: {
    id: 'PricingSummary.Feature.MaxCollectorsPerSurvey',
    defaultMessage: 'Max Collectors Per Survey',
    desc: TYPE_LABEL,
  },
  matrix_question_type: {
    id: 'PricingSummary.Feature.MatrixQuestionType',
    defaultMessage: 'Matrix Question Type',
    desc: TYPE_LABEL,
  },
  maximum_daily_messages: {
    id: 'PricingSummary.Feature.MaximumDailyMessages',
    defaultMessage: 'Maximum Daily Message',
    desc: TYPE_LABEL,
  },
  menu_matrix_enabled: {
    id: 'PricingSummary.Feature.MenuMatrixEnabled',
    defaultMessage: 'Menu Matrix Enabled',
    desc: TYPE_LABEL,
  },
  metadata_settings: {
    id: 'PricingSummary.Feature.MetadataSettings',
    defaultMessage: 'Metadata Settings',
    desc: TYPE_LABEL,
  },
  mobile_sdk_pull_response_data_enabled: {
    id: 'PricingSummary.Feature.MobileSdkPullResponseDataEnabled',
    defaultMessage: 'Mobile Sdk Pull Response Data',
    desc: TYPE_LABEL,
  },
  mta_sparkpost_low_risk_ip_pools: {
    id: 'PricingSummary.Feature.MtaSparkpostLowRiskIpPools',
    defaultMessage: 'MTA Sparkpost Low Risk Ip Pools',
    desc: TYPE_LABEL,
  },
  multilingual: {
    id: 'PricingSummary.Feature.Multilingual',
    defaultMessage: 'Multilingual surveys',
    desc: TYPE_LABEL,
  },
  multiple_users: {
    id: 'PricingSummary.Feature.MultipleUsers',
    defaultMessage: 'Multiple Users',
    desc: TYPE_LABEL,
  },
  new_stock_themes: {
    id: 'PricingSummary.Feature.NewStockThemes',
    defaultMessage: 'New Stock Themes',
    desc: TYPE_LABEL,
  },
  notification_center: {
    id: 'PricingSummary.Feature.NotificationCenter',
    defaultMessage: 'Notification Center',
    desc: TYPE_LABEL,
  },
  num_free_responses: {
    id: 'PricingSummary.Feature.NumFreeResponses',
    defaultMessage: '{amount} responses per month**',
    desc: TYPE_LABEL,
  },
  pagination: {
    id: 'PricingSummary.Feature.Pagination',
    defaultMessage: 'Pagination',
    desc: TYPE_LABEL,
  },
  paid_to_group_rollout: {
    id: 'PricingSummary.Feature.PaidToGroupRollout',
    defaultMessage: 'Paid To Group Rollout',
    desc: TYPE_LABEL,
  },
  papi_enabled: {
    id: 'PricingSummary.Feature.PapiEnabled',
    defaultMessage: 'Papi Enabled',
    desc: TYPE_LABEL,
  },
  password_protection: {
    id: 'PricingSummary.Feature.PasswordProtection',
    defaultMessage: 'Password Protection',
    desc: TYPE_LABEL,
  },
  payment_qt: {
    id: 'PricingSummary.Feature.PaymentQT',
    defaultMessage: 'Accept payments',
    desc: TYPE_LABEL,
  },
  phone_support: {
    id: 'PricingSummary.Feature.PhoneSupport',
    defaultMessage: 'Phone support and 24/7 email support',
    desc: TYPE_LABEL,
  },
  benchmark_logic: {
    id: 'PricingSummary.Feature.PlansBenchmark',
    defaultMessage: 'SurveyMonkey industry benchmarks',
    desc: TYPE_LABEL,
  },
  pop_up_collector: {
    id: 'PricingSummary.Feature.PopupCollector',
    defaultMessage: 'Popup Collector',
    desc: TYPE_LABEL,
  },
  premium_themes: {
    id: 'PricingSummary.Feature.PremiumThemes',
    defaultMessage: 'Premium Themes',
    desc: TYPE_LABEL,
  },
  priority_email_support: {
    id: 'PricingSummary.Feature.PrimaryEmailSupport',
    defaultMessage: '24/7 expedited email support',
    desc: TYPE_LABEL,
  },
  private_apps: {
    id: 'PricingSummary.Feature.PrivateApps',
    defaultMessage: 'Unlimited API access***',
    desc: TYPE_LABEL,
  },
  progress_bar: {
    id: 'PricingSummary.Feature.ProgressBar',
    defaultMessage: 'Progress Bar',
    desc: TYPE_LABEL,
  },
  question_library: {
    id: 'PricingSummary.Feature.QuestionLibrary',
    defaultMessage: 'Question Library',
    desc: TYPE_LABEL,
  },
  question_library_intl: {
    id: 'PricingSummary.Feature.QuestionLibraryIntl',
    defaultMessage: 'Question Library Intl',
    desc: TYPE_LABEL,
  },
  quizzes_pro: {
    id: 'PricingSummary.Feature.QuizzesPro',
    defaultMessage: 'Quizzes with custom feedback',
    desc: TYPE_LABEL,
  },
  randomize_answer_choices: {
    id: 'PricingSummary.Feature.RandomizeAnswerChoices',
    defaultMessage: 'Randomize Answer Choices',
    desc: TYPE_LABEL,
  },
  ranking_question_type: {
    id: 'PricingSummary.Feature.RankingQuestionType',
    defaultMessage: 'Ranking Question Type',
    desc: TYPE_LABEL,
  },
  rating_question_type: {
    id: 'PricingSummary.Feature.RatingQuestionType',
    defaultMessage: 'Rating Question Type',
    desc: TYPE_LABEL,
  },
  real_time_results: {
    id: 'PricingSummary.Feature.RealTimeResults',
    defaultMessage: 'Real Time Results',
    desc: TYPE_LABEL,
  },
  receive_transferred_survey_enabled: {
    id: 'PricingSummary.Feature.ReceiveTransferredSurveyEnabled',
    defaultMessage: 'Receive Transferred Survey Enabled',
    desc: TYPE_LABEL,
  },
  record_respondent_email_address: {
    id: 'PricingSummary.Feature.RecordRespondentEmailAddress',
    defaultMessage: 'Record Respondent Email Address',
    desc: TYPE_LABEL,
  },
  recurring_email_collector_enabled: {
    id: 'PricingSummary.Feature.RecurringEmailCollectorEnabled',
    defaultMessage: 'Recurring Email Collector Enabled',
    desc: TYPE_LABEL,
  },
  recurring_surveys: {
    id: 'PricingSummary.Feature.RecurringSurveys',
    defaultMessage: 'Recurring Surveys',
    desc: TYPE_LABEL,
  },
  require_answer: {
    id: 'PricingSummary.Feature.RequireAnswer',
    defaultMessage: 'Require Answeer',
    desc: TYPE_LABEL,
  },
  reshare: {
    id: 'PricingSummary.Feature.Reshare',
    defaultMessage: 'Reshare',
    desc: TYPE_LABEL,
  },
  respondent_receipt: {
    id: 'PricingSummary.Feature.RespondentReceipt',
    defaultMessage: 'Respondent Receipt',
    desc: TYPE_LABEL,
  },
  response_alerts: {
    id: 'PricingSummary.Feature.ResponseAlerts',
    defaultMessage: 'Notify others when you get new responses',
    desc: TYPE_LABEL,
  },
  response_quality_enabled: {
    id: 'PricingSummary.Feature.ResponseQualityEnabled',
    defaultMessage: 'Response Quality',
    desc: TYPE_LABEL,
  },
  responses_read: {
    id: 'PricingSummary.Feature.ResponsesRead',
    defaultMessage: 'Responses Read',
    desc: TYPE_LABEL,
  },
  responses_read_detail: {
    id: 'PricingSummary.Feature.ResponsesReadDetail',
    defaultMessage: 'Responses Read Detail',
    desc: TYPE_LABEL,
  },
  responses_write: {
    id: 'PricingSummary.Feature.ResponsesWrite',
    defaultMessage: 'Responses Write',
    desc: TYPE_LABEL,
  },
  roles_read: {
    id: 'PricingSummary.Feature.RolesRead',
    defaultMessage: 'Roles Read',
    desc: TYPE_LABEL,
  },
  roles_write: {
    id: 'PricingSummary.Feature.RolesWrite',
    defaultMessage: 'Roles Write',
    desc: TYPE_LABEL,
  },
  sa_en_ga: {
    id: 'PricingSummary.Feature.SaEnGa',
    defaultMessage: 'SA EN GA',
    desc: TYPE_LABEL,
  },
  select_features_included: {
    id: 'PricingSummary.Feature.SelectFeaturesIncluded',
    defaultMessage: 'Select Features Included',
    desc: TYPE_LABEL,
  },
  send_surveys: {
    id: 'PricingSummary.Feature.SendSurveys',
    defaultMessage: 'Send Surveys',
    desc: TYPE_LABEL,
  },
  set_max_response_count: {
    id: 'PricingSummary.Feature.SetMaxResponseCount',
    defaultMessage: 'Set Max Response Count',
    desc: TYPE_LABEL,
  },
  set_survey_end_date: {
    id: 'PricingSummary.Feature.SetSurveyEndDate',
    defaultMessage: 'Set Survey End Date',
    desc: TYPE_LABEL,
  },
  share_surveys: {
    id: 'PricingSummary.Feature.ShareSurveys',
    defaultMessage: 'Share Surveys',
    desc: TYPE_LABEL,
  },
  share_with_your_organization: {
    id: 'PricingSummary.Feature.ShareWithYourOrganization',
    defaultMessage: 'Share With Your Organization',
    desc: TYPE_LABEL,
  },
  shared_assets: {
    id: 'PricingSummary.Feature.SharedAssets',
    defaultMessage: 'Shared asset library for on-brand surveys',
    desc: TYPE_LABEL,
  },
  shared_group_library: {
    id: 'PricingSummary.Feature.SharedGroupLibrary',
    defaultMessage: 'Shared Group Library',
    desc: TYPE_LABEL,
  },
  shared_library: {
    id: 'PricingSummary.Feature.SharedLibrary',
    defaultMessage: 'Shared Library',
    desc: TYPE_LABEL,
  },
  show_create_crosstab: {
    id: 'PricingSummary.Feature.ShowCreateCrosstab',
    defaultMessage: 'Crosstabs',
    desc: TYPE_LABEL,
  },
  show_create_header_upgrade_button: {
    id: 'PricingSummary.Feature.ShowCreateHeaderUpgradeButton',
    defaultMessage: 'Show Create Header Upgrade Button',
    desc: TYPE_LABEL,
  },
  show_sig_diffs_enabled: {
    id: 'PricingSummary.Feature.ShowSigDiffsEnabled',
    defaultMessage: 'Show Sig Diffs Enabled',
    desc: TYPE_LABEL,
  },
  single_sign_on: {
    id: 'PricingSummary.Feature.SingleSignOn',
    defaultMessage: 'Single sign-on (SSO)',
    desc: TYPE_LABEL,
  },
  slider_question_type: {
    id: 'PricingSummary.Feature.SliderQuestionType',
    defaultMessage: 'Slider Question Type',
    desc: TYPE_LABEL,
  },
  smart_notifications: {
    id: 'PricingSummary.Feature.SmartNotifications',
    defaultMessage: 'Smart Notifications',
    desc: TYPE_LABEL,
  },
  ssl_tls_encryption: {
    id: 'PricingSummary.Feature.SslTlsEncryption',
    defaultMessage: 'SSL/TLS Encryption',
    desc: TYPE_LABEL,
  },
  star_rating_question_type: {
    id: 'PricingSummary.Feature.StarRatingQuestionType',
    defaultMessage: 'Star Rating Question Type',
    desc: TYPE_LABEL,
  },
  statistical_significance: {
    id: 'PricingSummary.Feature.StatisticalSignifcance',
    defaultMessage: 'Text analysis & statistical significance',
    desc: TYPE_LABEL,
  },
  survey_branding: {
    id: 'PricingSummary.Feature.SurveyBranding',
    defaultMessage: 'Custom logo, colors, and survey URL',
    desc: TYPE_LABEL,
  },
  survey_create_limit: {
    id: 'PricingSummary.Feature.SurveyCreateLimit',
    defaultMessage: 'Unlimited number of surveys',
    desc: TYPE_LABEL,
  },
  survey_templates_intl: {
    id: 'PricingSummary.Feature.SurveyTemplatesIntl',
    defaultMessage: 'Survey Templates Intl',
    desc: TYPE_LABEL,
  },
  surveys_read: {
    id: 'PricingSummary.Feature.SurveysRead',
    defaultMessage: 'Surveys Read',
    desc: TYPE_LABEL,
  },
  surveys_write: {
    id: 'PricingSummary.Feature.SurveysWrite',
    defaultMessage: 'Surveys Write',
    desc: TYPE_LABEL,
  },
  team_activity: {
    id: 'PricingSummary.Feature.TeamActivity',
    defaultMessage: 'Activity tracking through audit logs',
    desc: TYPE_LABEL,
  },
  team_logic: {
    id: 'PricingSummary.Feature.TeamLogic',
    defaultMessage: 'Add or reassign accounts at any time',
    desc: TYPE_LABEL,
  },
  team_ownership: {
    id: 'PricingSummary.Feature.TeamOwnership',
    defaultMessage: 'Team Ownership',
    desc: TYPE_LABEL,
  },
  team_themes: {
    id: 'PricingSummary.Feature.TeamThemes',
    defaultMessage: 'Team Themes',
    desc: TYPE_LABEL,
  },
  teams_can_discover: {
    id: 'PricingSummary.Feature.TeamsCanDiscover',
    defaultMessage: 'Teams Can Discover',
    desc: TYPE_LABEL,
  },
  teams_can_make_discoverable: {
    id: 'PricingSummary.Feature.TeamsCanMakeDiscoverable',
    defaultMessage: 'Teams Can Make Discoverable',
    desc: TYPE_LABEL,
  },
  teams_enabled: {
    id: 'PricingSummary.Feature.TeamsEnabled',
    defaultMessage: 'Teams Enabled',
    desc: TYPE_LABEL,
  },
  text_analysis: {
    id: 'PricingSummary.Feature.TextAnalysis',
    defaultMessage: 'Text analysis',
    desc: TYPE_LABEL,
  },
  text_formatting: {
    id: 'PricingSummary.Feature.TextFormatting',
    defaultMessage: 'Text Formatting',
    desc: TYPE_LABEL,
  },
  textbox_multiple_question_type: {
    id: 'PricingSummary.Feature.TextboxMultipleQuestionType',
    defaultMessage: 'Textbox Multiple Question Type',
    desc: TYPE_LABEL,
  },
  track_email_responses: {
    id: 'PricingSummary.Feature.TrackEmailResponses',
    defaultMessage: 'Track Email Responses',
    desc: TYPE_LABEL,
  },
  try_before_you_buy_enabled: {
    id: 'PricingSummary.Feature.TryBeforeYouBuyEnabled',
    defaultMessage: 'Try Before You Buy Enabled',
    desc: TYPE_LABEL,
  },
  unlimited_questions: {
    id: 'PricingSummary.Feature.UnlimitedQuestions',
    defaultMessage: 'Unlimited questions per survey',
    desc: TYPE_LABEL,
  },
  unlimited_responses: {
    id: 'PricingSummary.Feature.UnlimitedResponses',
    defaultMessage: 'Unlimited surveys and questions',
    desc: TYPE_LABEL,
  },
  user_management: {
    id: 'PricingSummary.Feature.UserManagment',
    defaultMessage: 'User Management',
    desc: TYPE_LABEL,
  },
  users_read: {
    id: 'PricingSummary.Feature.UsersRead',
    defaultMessage: 'Users Read',
    desc: TYPE_LABEL,
  },
  validate_answer: {
    id: 'PricingSummary.Feature.ValidateAnswer',
    defaultMessage: 'Validate Answer',
    desc: TYPE_LABEL,
  },
  video_question_type: {
    id: 'PricingSummary.Feature.VideoQuestionType',
    defaultMessage: 'Video Question Type',
    desc: TYPE_LABEL,
  },
  view_respondent_ip_address: {
    id: 'PricingSummary.Feature.ViewRespondentIpAddrress',
    defaultMessage: 'View Responded Ip Address',
    desc: TYPE_LABEL,
  },
  webhooks_read: {
    id: 'PricingSummary.Feature.WebhooksRead',
    defaultMessage: 'Webhooks Read',
    desc: TYPE_LABEL,
  },
  webhooks_write: {
    id: 'PricingSummary.Feature.WebhooksWrite',
    defaultMessage: 'Webhooks Write',
    desc: TYPE_LABEL,
  },
  workgroups_members_read: {
    id: 'PricingSummary.Feature.WorkgroupsMembersRead',
    defaultMessage: 'Workgroups Members Read',
    desc: TYPE_LABEL,
  },
  workgroups_members_write: {
    id: 'PricingSummary.Feature.WorkgroupsMembersWrite',
    defaultMessage: 'Workgroups Members Write',
    desc: TYPE_LABEL,
  },
  workgroups_read: {
    id: 'PricingSummary.Feature.WorkgroupsRead',
    defaultMessage: 'Workgroups Read',
    desc: TYPE_LABEL,
  },
  workgroups_shares_read: {
    id: 'PricingSummary.Feature.WorkgroupsSharesRead',
    defaultMessage: 'Workgroups Shares Read',
    desc: TYPE_LABEL,
  },
  workgroups_shares_write: {
    id: 'PricingSummary.Feature.WorkgroupsSharesWrite',
    defaultMessage: 'Workgroups Shares Write',
    desc: TYPE_LABEL,
  },
  workgroups_write: {
    id: 'PricingSummary.Feature.WorkgroupsWrite',
    defaultMessage: 'Workgroups Write',
    desc: TYPE_LABEL,
  },
});
